import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {  NgbDatepickerModule, NgbModule, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule, BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { SmErrorModule } from 'common/components/ui-components/sm-error/sm-error.module';
import { SmDatetimepickerComponent } from './sm-datetimepicker.component';



@NgModule({
  declarations: [SmDatetimepickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    SmErrorModule,
    NgbPopover,
    NgbModule,
    BsDatepickerModule.forRoot(),
    NgbDatepickerModule
  ],
  providers: [BsDatepickerConfig, DatePipe],
  exports:[SmDatetimepickerComponent]
})
export class SmDatetimepickerModule { }